import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    min-width: 0;

    >label{
        display: block;
        margin-bottom: 10px;
        font-size: 0.875rem;
        line-height: 1.35;
        font-weight: 600;
        color: #334155;
        word-break: break-word;

        >p{
            font-size: 10px;
            font-weight: bold;
        }
    }

    input{
        width: 100%;
    }

    >p{
        font-size: 12px;
        line-height: 1.45;
        margin-top: 8px;
    }

    @media(max-width: 767px){
        width: 100%;

        >label{
            margin-top: 0;
            margin-bottom: 10px;
        }

        input{
            width: 100%;
        }
    }
`;
